import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;


 export const fetchImcList = createAsyncThunk(
    'imcs/fetchImcList',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/imc/v1/list`, rejectWithValue)
 )

 export const createUpdateImc = createAsyncThunk(
   'imcs/createUpdateImc',
   (arg, { rejectWithValue }) => DataService.post(arg, path+'client/imc/v1/edit-imc', rejectWithValue)
)

 export const downLoadImcReportDatewise = createAsyncThunk(
   'imcs/downLoadImcReportDatewise',
   (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/imc/v1/datewise-report/${arg?.dateData}`, rejectWithValue)
)

export const downLoadImcReport = createAsyncThunk(
   'imcs/downLoadImcReport',
   (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/imc/v1/current-report`, rejectWithValue)
)

export const fetchImcAuditTrailList = createAsyncThunk(
   'imcs/fetchImcAuditTrailList',
   (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/imc/v1/audit-trails', rejectWithValue)
)

export const downLoadImcReportInCSVDatewise = createAsyncThunk(
   'imcs/downLoadImcReportInCSVDatewise',
   (arg, { rejectWithValue }) => DataService.post(arg,  path+`client/imc/v1/csv-reports`, rejectWithValue)
)

export const downLoadImcReportInXLXDatewise = createAsyncThunk(
   'imcs/downLoadImcReportInXLXDatewise',
   (arg, { rejectWithValue }) => DataService.post(arg,  path+`client/imc/v1/excel-reports`, rejectWithValue)
)

export const sendImcReportToShrewd = createAsyncThunk(
   'imcs/sendImcReportToShrewd',
   (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/imc/v1/send-to-shrewd`, rejectWithValue)
)

// Report Time Slot Actions
export const AddIMCTime = createAsyncThunk(
  "imc/AddIMCTime",
  (arg, { rejectWithValue }) =>
    DataService.post(arg, path + "client/account/v1/add-imc-time-slot", rejectWithValue)
);

export const EditIMCTime = createAsyncThunk(
  "imc/EditIMCTime",
  (arg, { rejectWithValue }) =>
    DataService.post(arg, path + "client/account/v1/update-imc-time-slot", rejectWithValue)
);

export const deleteIMCTime = createAsyncThunk(
  "imc/deleteIMCTime",
  (arg, { rejectWithValue }) =>
    DataService.delete(arg, path + "client/account/v1/delete-imc-time-slot", rejectWithValue)
);

export const toggleIMCTimeActivation = createAsyncThunk(
  "imc/toggleIMCTimeActivation",
  (arg, { rejectWithValue }) =>
    DataService.post(arg, path + "client/account/v1/toggle-imc-time-slot", rejectWithValue)
);

